import React from "react";
import { Box, Typography } from "@mui/material";
import { Controller, type Control, type FieldPath } from "react-hook-form";
import type { TargetFormData, TargetType } from "../types";
import { TARGET_TYPE_OPTIONS } from "../consts";
import { targetTypeOptionSx } from "../styles";

export interface TargetTypeFieldProps {
  control: Control<TargetFormData>;
}

export const TargetTypeField = ({ control }: TargetTypeFieldProps) => (
  <>
    <Box sx={{ display: "flex", alignItems: "flex-start", gap: "4px" }}>
      <Typography sx={{ fontSize: "12px", color: "black", fontWeight: 600, mb: "4px" }}>
        Target Type
      </Typography>
      <Typography component="span" sx={{ color: "red", fontSize: "12px", fontWeight: 600 }}>*</Typography>
    </Box>
    <Box sx={{ display: "flex", gap: 2, width: "100%" }}>
      {TARGET_TYPE_OPTIONS.map((opt) => (
        <Controller
          key={opt.value}
          name={"targetType" as FieldPath<TargetFormData>}
          control={control}
          render={({ field }) => (
            <Box
              component="label"
              sx={targetTypeOptionSx(field.value === (opt.value as TargetType))}
            >
              <input
                type="radio"
                checked={field.value === opt.value}
                onChange={() => field.onChange(opt.value)}
                style={{ marginRight: 8, marginTop: "0px" }}
              />
              {opt.label}
            </Box>
          )}
        />
      ))}
    </Box>
  </>
);
